module.exports = __webpack_public_path__ + "media/images/iconDown__inactive-1a1d9fa9b1b13eab4534fa891817a885.png";